<template>
  <o-modal
    ref="modal"
  >
    <o-modal-pane
      :title="pageData.modal.title"
    >
      <span>{{ pageData.modal.salesPitch }}</span>
      <template slot="actions">
        <o-button
          href="//www.weebly.com/signup"
          variant="primary"
          size="large"
          @click="handleSignUpClick"
        >
          {{ pageData.modal.cta }}
        </o-button>
        <o-button
          :href="generatedTermsUrl"
          size="large"
          @click.native="closeModal()"
        >
          {{ pageData.modal.termsLink }}
        </o-button>
      </template>
    </o-modal-pane>
  </o-modal>
</template>

<script>
import { OModal, OModalPane } from 'orbit-ui/components/Modal';
import { OButton } from 'orbit-ui/components/Button';
import { CLICK } from '@weebly/aragorn-analytics/dist/constants/actions';
import { SIGNUP_BUTTON } from '@weebly/aragorn-analytics/dist/constants/categories';

export default {
  name: 'TermsGeneratorSuccessModal',

  components: {
    OModal,
    OModalPane,
    OButton,
  },

  props: {
    generatedTermsUrl: {
      type: String,
      default: '',
    },
    pageData: {
      type: Object,
      default: () => ({}),
    },
    termsProperties: {
      type: Object,
      default: () => ({}),
    },
  },

  methods: {
    handleSignUpClick() {
      this.$analytics.track({
        type: 'standard',
        location: this.termsProperties.trackingLocation,
        object_category: SIGNUP_BUTTON,
        action: CLICK,
        object_instance: 'start_website_modal',
      });
    },

    closeModal() {
      if (this.$refs.modal) {
        this.$refs.modal.close();
      }
    },
  },
};
</script>

